__turbopack_context__.v({
  "error": "NewsDetailPage-module-scss-module__mt5UdW__error",
  "loading": "NewsDetailPage-module-scss-module__mt5UdW__loading",
  "newsDetailPage": "NewsDetailPage-module-scss-module__mt5UdW__newsDetailPage",
});
